module.exports = __webpack_public_path__ + "static/media/signage-industrial-img7.4c87f994.jpg";